import React, { useState } from 'react';
import css from './FilterSidebar.module.css';
import { FieldConfigKey } from '../../../util/enums';
import { createFilterOptions } from '../../../util/genericHelpers';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

const InterestsFilterSection = ({
  userFields,
  paramKey,
  handleClearFilter,
  handleCheckboxChange,
  selectedValues,
  isBlackBgFilter,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const interestKeyConfig = userFields.find(f => f.key === FieldConfigKey.INTEREST) || {};
  const interestFilterOptions = createFilterOptions(interestKeyConfig.enumOptions) || [];

  // Filter options based on the search term (case insensitive)
  const filteredInterests = interestFilterOptions.filter(opt =>
    opt.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleClear = () => {
    handleClearFilter(paramKey);
    setSearchTerm('');
  };
  return (
    <div className={css.filterSection}>
      <div className={classNames(isBlackBgFilter ? css.blackBgFilter : null, css.sectionHeader)}>
        <h3>
          <FormattedMessage id="FilterCategories.interests" />
        </h3>
        <button className={css.clearButton} onClick={handleClear}>
          <FormattedMessage id="FilterCategories.clear" />
        </button>
      </div>
      {/* Search Input */}
      <input
        type="text"
        className={css.searchInput}
        placeholder="Search interests..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />
      <div className={css.scrollable}>
        {filteredInterests.map(opt => {
          const optionKey = opt.value;
          const isChecked = selectedValues.includes(optionKey);
          return (
            <label key={optionKey} className={css.checkboxLabel}>
              <input
                type="checkbox"
                value={opt.value}
                checked={isChecked}
                onChange={e => handleCheckboxChange(e, paramKey)}
                name="interest"
              />
              <span>{opt.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default InterestsFilterSection;
